import React from 'react';
import { TWILIGHT_NAVY, LIVING_CORAL, SHELL_WHITE } from '../../../theme/colors';
import { FEATURES_HEADER, FEATURE_CARDS } from './featuresData';
import FeatureCardMobile from './FeatureCardMobile';

// The header sits in normal flow; the 4 cards that follow are each their own
// independent, self-contained pin-then-release unit (see FeatureCardMobile.js)
// — no inter-card z-index/covering relationship, each just hands off to the
// next via plain sequential scroll.
const FeaturesMobile = () => (
  <div style={{ width: '100%', backgroundColor: SHELL_WHITE }}>
    <div style={{ display: 'flex', flexDirection: 'column', padding: '56px 20px 28px' }}>
      <span style={{ fontFamily: 'DM Sans', fontSize: 10, fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: LIVING_CORAL }}>
        {FEATURES_HEADER.eyebrow}
      </span>
      <span style={{ fontFamily: 'Instrument Serif', fontSize: 26, lineHeight: 1.25, color: TWILIGHT_NAVY, marginTop: 12 }}>
        {FEATURES_HEADER.headline}
      </span>
    </div>

    <div style={{ position: 'relative' }}>
      {FEATURE_CARDS.map((feature) => (
        <FeatureCardMobile key={feature.number} feature={feature} />
      ))}
    </div>
  </div>
);

export default FeaturesMobile;
